import { Component, Input, OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { Webcam } from '../models/webcam.model';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditWebcamComponent } from '../edit-webcam/edit-webcam.component';
import { DeleteWebcamComponent } from '../delete-webcam/delete-webcam.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';


@Component({
  selector: 'app-business-webcams',
  templateUrl: './business-webcams.component.html',
  styleUrls: ['./business-webcams.component.scss']
})
export class BusinessWebcamsComponent implements OnInit {
  @Input() business: Business;
  editModeSet: boolean;
  isRegionalManager = false;

  constructor(private _toggleService: EditToggleService,
              public _snackBar: MatSnackBar,
              private _editWebcamDialog: MatDialog,
              private _deleteWebcamDialog: MatDialog,
              private _businessManagerService: BusinessManagerService) { }

  async ngOnInit() {
    this.editModeSet = this._toggleService.getState();
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
    this.isRegionalManager = await this._businessManagerService.isRegionalManager()
      && !await this._businessManagerService.userOwnsBusiness(this.business.id);
  }

  webcamUrl(url: string): string {
    const website = url || '';
    if (url.indexOf('http://') >= 0 || url.indexOf('https://') >= 0) {
      return url;
    } else {
      return 'http://' + url;
    }
  }

  openEditWebcamDialog(index: number) {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '60%';
    dialogConfig.data = {
      businessID: this.business.id,
      webcam: null,
      isNew: false,
    };
    index == null ? dialogConfig.data.isNew = true : dialogConfig.data.webcam = this.business.webcams[index];
    dialogConfig.data['busID'] = this.business.id;
    dialogConfig.width = '60%';
    const dialogRef = this._editWebcamDialog.open(EditWebcamComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      // this.reloadAirport(this.business.identifier);
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
      if (isUpdated.success) {
        if (isUpdated.isNew) {
          // this.airport.pilotControlledLighting.push(isUpdated.pcl);
          this.business.webcams.push(isUpdated.webcam);
          this._snackBar.open('Webcam', 'Added', {
            duration: 2000
          });
        } else {
          this._snackBar.open('Webcam', 'Updated', {
            duration: 2000
          });
        }
      } else {
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }

  deleteWebcam(index: number) {
    const dialogConfig = new MatDialogConfig();
     const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.data = {
       businessID: this.business.id,
       webcamId: this.business.webcams[index].webcamId
     };
     const dialogRef = this._deleteWebcamDialog.open(DeleteWebcamComponent, dialogConfig);
     dialogRef.afterClosed().subscribe((isUpdated) => {
       if (!isUpdated) { return; } // required to handle backdrop click.
       if (isUpdated.cancelBtnClicked) { return; }
       // isUpdated.success will be false if there is an error during any of the api calls.
       if (isUpdated.success) {
         this._snackBar.open('Webcam', 'Deleted', {
           duration: 2000
         });
         this.business.webcams.splice(index, 1);
         // this.reloadAirport(this.airport.identifier);
       } else {
         this._snackBar.open(ERROR_MSG, 'Error', {
           duration: 6000
         });
       }
     });
  }
}
